<template>
    <div class="dialog-screen">
        <div class="table-layout">
            <el-table class="thin" :data="pageDeviceImpInfoList" :height="tableHeight" ref="deviceImpInfoTable" border style="width: 100%; font-size: 12px" @selection-change="handleSelectionChange" :row-class-name="markSelectedRowClassName">
                <el-table-column type="selection" width="40" align="center" fixed="left"></el-table-column>
                <el-table-column label="源件" width="60" align="center" fixed="left">
                    <el-table-column prop="rowNo" label="行号" width="60" align="center"></el-table-column>
                </el-table-column>
                <el-table-column prop="failed" label="执行状态" width="60" align="center" fixed="left" v-show="startFlag">
                    <template slot-scope="rows">
                        <div v-if="rows.row.failed != null">
                            <span v-if="rows.row.failed" style="color: red;font-size: 20px">×</span>
                            <span v-else style="color: green;font-size: 20px">√</span>
                        </div>
                        <span v-else class="font-gray3">未执行</span>
                    </template>
                </el-table-column>
                <el-table-column prop="failDesc" label="失败描述" width="500" align="left" fixed="left" v-show="startFlag"></el-table-column>
                <el-table-column label="系统编号">
                    <el-table-column prop="tmpNo"></el-table-column>
                </el-table-column>
                <el-table-column label="外部系统编号">
                    <el-table-column prop="innerNo" width="220"></el-table-column>
                </el-table-column>
                <el-table-column label="未结算资产" align="center">
                    <el-table-column prop="outerUnsettled" width="120">
                        <template slot-scope="rows">
                            <span>{{rows.row.outerUnsettled ? '是' : '否'}}</span>
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div class="clearfix">
            <el-pagination background class="fl mt5" v-if="totalCount > 0" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="prev, pager, next, jumper, sizes, total"></el-pagination>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="doDeviceImpModelImport">导入</div>
            <div class="swb-btn swb-btn-small fr mt10 mr10" @click="validateDeviceImpModel(true)">逐条检查</div>
        </div>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { openPageRouteUrl, getDefaultPageSizes } from '../../../src/app.conf'
    import { showMerchtDevcDefSelectDlg, openDevcDefDetailDlg } from '../devcDef/showDlg'
    import { openCategTreeSelectDlg, openBrandListSelectDlg, showDevcCatSelectDlg, showDevcBrandSelectDlg } from '../categ/selectDlg'
    import { openComStaffComnSelectDlg } from '../orgStruct/selectDlg'
    import { getMerchantBizParam } from '../asset/assetMain'

    import shopDevcApi from '../../api/shopDevc'
    import retailerApi from '../../api/retailer'
    import shopStockApi from '../../api/shopStock'
    import userApi from '../../api/user'
    import devcDefApi from '../../api/devcDef'

    import SwbCategTree from '../categ/CategTree';
    Vue.regist(SwbCategTree);
    import SwbDefServicerForSelect from '../servicer/DefServicerForSelect';
    Vue.regist(SwbDefServicerForSelect);
    import SwbBrandSelect from '../categ/BrandSelect';
    Vue.regist(SwbBrandSelect);
    import SwbShopDeviceImpSetDate from './ShopDeviceImpSetDate';
    Vue.regist(SwbShopDeviceImpSetDate);

    export default {
        name: 'swb-shop-device-outer-unsettled-imp-devc-check',
        desc: '机构设备导入检查',
        props: ['fileObj', 'rootWidth', 'rootHeight', 'theDlg'],
        data: function () {
            return {
                tableHeight: 0,
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: [15, 50, 100, 200],// 特殊页面处理
                pageDeviceImpInfoList: {},
                deviceImpDto: {
                    retailerShopId: null,
                    originalFileName: null,
                    deviceImpInfoList: [],
                    dumyBrandNames: [],
                    warehouseId: null,
                    warehouseName: null,
                    srcVoucherType: null,
                    srcVoucherNo: null,
                    importRecId: null,
                    ioVoucherId: null
                },
                isOk: false,
                theLoading: null,
                multipleSelection: [],
                virtualBrandStr: '',
                max_quantity_per_item: 500,
                acctEnterWayList: getEnumList('acctEnterWay'),
                deviceUseStateList: getEnumList('deviceUseState'),
                devcVoucherTypeList: getEnumList('devcVoucherType'),
                warehouseList: [],
                startFlag: false, // 标记是否已开始逐条执行
                nextIndex: 0,
                checkNextIndex: 0,
                scopeId: null,
                assetDeprMethodList: [],
                uknoPrefix: null,
            }
        },
        watch: {
            rootWidth(newVal, oldVal){
                //
            },
            rootHeight(newVal, oldVal){
                this.recalcTableHeight();
            }
        },
        created: function () {
            this.recalcTableHeight();
            this.assetDeprMethodList = getEnumList('assetDeprMethod');
            //
            let self = this;
            let theLoading = MsgBox.loading();
            this.deviceImpDto.retailerShopId = this.fileObj.extra.retailerShopId;
            this.deviceImpDto.retailerBizUnitId = this.fileObj.extra.retailerBizUnitId;
            this.deviceImpDto.originalFileName = this.fileObj.extra.originalFileName;
            this.deviceImpDto.deviceFlag = this.fileObj.extra.deviceFlag;
            this.deviceImpDto.durable = this.fileObj.extra.durable;
            let deviceImpInfoList = this.fileObj.extra.deviceImpInfoList;
            deviceImpInfoList.forEach(function (el) {
                el.validateInfo = {
                    devcDefId: {validateOk: true},
                    batchNo: {validateOk: true},
                    innerCode: {validateOk: true},
                    innerNo: {validateOk: true},
                    upn: {validateOk: true},
                    devcName: {validateOk: true},
                    title: {validateOk: true},
                    shopName: {validateOk: true},
                    bizUnitName: {validateOk: true},
                    initStartDate: {validateOk: true},
                    startDate: {validateOk: true},
                    innerDevcCatName: {validateOk: true},
                    innerDevcCatCode: {validateOk: true},
                    innerDevcBrandName: {validateOk: true},
                    innerDevcBrandCode: {validateOk: true},
                    catName: {validateOk: true},
                    brandName: {validateOk: true},
                    model: {validateOk: true},
                    fixedSpec: {validateOk: true},
                    innerVendorNo: {validateOk: true},
                    vendorSn: {validateOk: true},
                    quantity: {validateOk: true},
                    theUnit: {validateOk: true},
                    buyDate: {validateOk: true},
                    recvDate: {validateOk: true},
                    servicerName: {validateOk: true},
                    wrntPeriod: {validateOk: true},
                    departName: {validateOk: true},
                    principalName: {validateOk: true},
                    memo: {validateOk: true}
                };
            });
            this.deviceImpDto.deviceImpInfoList = deviceImpInfoList;

            this.pageSize = this.pageSizes.first();
            self.checkData();
            self.setPageDeviceImpInfoList();
            self.getWarehouseList();
            this.getCurrUserInfo();
            theLoading.close();
        },
        methods: {
            getCurrUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        self.scopeId = result.data.scopeEntity.scopeId;
                        self.getRetailer(result.data.scopeEntity.id);
                    }
                });
            },
            getRetailer: function (merchantId) {
                let self = this;
                retailerApi.getRetailer({retailerId: merchantId}, function (result) {
                    if(result.type == 'info') {
                        self.uknoPrefix = result.data.uknoPrefix;
                    }
                });
            },
            getWarehouseList(){
                let self = this;
                let postData = {};
                let retailerShopId = self.deviceImpDto.retailerShopId;
                if(!Utils.isNoB(retailerShopId)) {
                    postData.filterItems = {
                        retailerShopId: retailerShopId
                    }
                }
                let msgBoxDlg = MsgBox.loading();
                shopStockApi.getShopWarehouseNotPageList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        self.warehouseList = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            recalcTableHeight(){
                this.tableHeight = this.rootHeight - 60 - 42;
            },
            markSelectedRowClassName(row){
                return this.multipleSelection.find(function (tmpRow) {
                    return tmpRow.rowNo == row.rowNo;
                }) != null ? 'selected-row' : '';
            },
            //自动合并数据行
            autoMergeItems(){
                let deviceImpInfoList = this.deviceImpDto.deviceImpInfoList.clone();
                //汇总
                let tmpList = deviceImpInfoList.split(function (item) {
                    let values = [];
                    values.add(item.devcDefId == null ? "" : item.devcDefId);
                    values.add(item.batchNo == null ? "" : item.batchNo.trim());
                    values.add(item.innerCode == null ? "" : item.innerCode.trim());
                    values.add(item.upn == null ? "" : item.upn.trim());
                    values.add(item.devcName == null ? "" : item.devcName.trim());
                    values.add(item.title == null ? "" : item.title.trim());
                    values.add(item.shopName == null ? "" : item.shopName.trim());
                    values.add(item.bizUnitName == null ? "" : item.bizUnitName.trim());
                    values.add(item.innerDevcCatName == null ? "" : item.innerDevcCatName.trim());
                    values.add(item.innerDevcCatCode == null ? "" : item.innerDevcCatCode.trim());
                    values.add(item.innerDevcBrandName == null ? "" : item.innerDevcBrandName.trim());
                    values.add(item.innerDevcBrandCode == null ? "" : item.innerDevcBrandCode.trim());
                    values.add(item.catName == null ? "" : item.catName.trim());
                    values.add(item.brandName == null ? "" : item.brandName.trim());
                    values.add(item.model == null ? "" : item.model.trim());
                    values.add(item.fixedSpec == null ? "" : item.fixedSpec.trim());
                    values.add(item.buyDate == null ? "" : item.buyDate.trim());
                    values.add(item.recvDate == null ? "" : item.recvDate.trim());
                    values.add(item.servicerName == null ? "" : item.servicerName.trim());
                    values.add(item.wrntPeriod == null ? "" : item.wrntPeriod);
                    values.add(item.acctEnterWay == null ? "" : item.acctEnterWay);
                    values.add(item.useState == null ? "" : item.useState);
                    values.add(item.departName == null ? "" : item.departName.trim());
                    values.add(item.principalName == null ? "" : item.principalName.trim());
                    values.add(item.theUnit == null ? "" : item.theUnit.trim());
                    values.add(item.durable == null ? "" : item.durable);
                    values.add(item.vendorSn == null ? "" : item.vendorSn.trim());
                    return values.join("::");
                });
                deviceImpInfoList = [];
                tmpList.forEach(function (sameItems) {
                    let first = Utils.merge({}, sameItems.first());
                    first.quantity = sameItems.sum(function (el) {
                        if(typeof el == 'undefined') {
                            //返回初始值
                            return 0;
                        }
                        else {
                            return el.quantity == null ? 0 : el.quantity;
                        }
                    });
                    //
                    deviceImpInfoList.add(first);
                });
                //排序（分类、品牌、购买日期、收货日期、店铺）
                deviceImpInfoList = sortArray(deviceImpInfoList, function (e1, e2) {
                    let tmpVal1 = "";
                    let tmpVal2 = "";
                    //
                    tmpVal1 = e1.innerDevcCatName || "";
                    tmpVal2 = e2.innerDevcCatName || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    tmpVal1 = e1.innerDevcBrandName || "";
                    tmpVal2 = e2.innerDevcBrandName || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.catName || "";
                    tmpVal2 = e2.catName || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.brandName || "";
                    tmpVal2 = e2.brandName || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.buyDate || "";
                    tmpVal2 = e2.buyDate || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.recvDate || "";
                    tmpVal2 = e2.recvDate || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.shopName || "";
                    tmpVal2 = e2.shopName || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    tmpVal1 = e1.bizUnitName || "";
                    tmpVal2 = e2.bizUnitName || "";
                    if(tmpVal1 != tmpVal2) {
                        return tmpVal1 > tmpVal2 ? 1 : -1;
                    }
                    //
                    return 0;
                });
                //console.log(deviceImpInfoList);
                this.deviceImpDto.deviceImpInfoList = deviceImpInfoList;
                this.checkData();
            },
            commonChangeEvent(row, colName){
                if(!Utils.isNoB(colName) && colName == 'durable') {
                    this.delDevcDef(row);
                } else {
                    this.checkData();
                }
            },
            quantityChangeEvent(value){
                this.checkData();
            },
            checkData () {
                let self = this;
                let rows = this.deviceImpDto.deviceImpInfoList.clone();
                let itemLength = rows.length;
                let byItemFlag = itemLength > 500;
                for(let i = 0; i < rows.length; i++) {
                    let deviceImpDto = rows[i];
                    deviceImpDto.validateInfo = {
                        devcDefId: {validateOk: true},
                        batchNo: {validateOk: true},
                        innerCode: {validateOk: true},
                        innerNo: {validateOk: true},
                        upn: {validateOk: true},
                        devcName: {validateOk: true},
                        title: {validateOk: true},
                        shopName: {validateOk: true},
                        bizUnitName: {validateOk: true},
                        initStartDate: {validateOk: true},
                        innerDevcCatName: {validateOk: true},
                        innerDevcCatCode: {validateOk: true},
                        innerDevcBrandName: {validateOk: true},
                        innerDevcBrandCode: {validateOk: true},
                        catName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        innerVendorNo: {validateOk: true},
                        vendorSn: {validateOk: true},
                        quantity: {validateOk: true},
                        theUnit: {validateOk: true},
                        buyDate: {validateOk: true},
                        recvDate: {validateOk: true},
                        servicerName: {validateOk: true},
                        wrntPeriod: {validateOk: true},
                        departName: {validateOk: true},
                        principalName: {validateOk: true},
                        memo: {validateOk: true}
                    };
                    if(Utils.isNoB(deviceImpDto.devcDefId)) {
                        deviceImpDto.validateInfo.devcDefId = {
                            validateOk: false,
                            errorMsg: "[关联定义]单元不能为空"
                        };
                    }
                    // 检查修正 [批次号]
                    if(!Utils.isNoB(deviceImpDto.batchNo)) {
                        deviceImpDto.batchNo = this.replaceSL(deviceImpDto.batchNo, '');
                        if(deviceImpDto.batchNo.length > 20) {
                            deviceImpDto.validateInfo.batchNo = {
                                validateOk: false,
                                errorMsg: "[批次号]单元长度最大20，当前[" + deviceImpDto.batchNo.length + "]"
                            };
                        }
                    } else {
                        deviceImpDto.validateInfo.batchNo = {
                            validateOk: false,
                            errorMsg: "[批次号]单元不能为空"
                        };
                    }
                    // 检查修正 [批次号]
                    if(!Utils.isNoB(deviceImpDto.innerCode)) {
                        deviceImpDto.innerCode = this.replaceSL(deviceImpDto.innerCode, '');
                        if(deviceImpDto.innerCode.length > 20) {
                            deviceImpDto.validateInfo.innerCode = {
                                validateOk: false,
                                errorMsg: "[资产编号]单元长度最大20，当前[" + deviceImpDto.innerCode.length + "]"
                            };
                        }
                    } else {
                        deviceImpDto.validateInfo.innerCode = {
                            validateOk: false,
                            errorMsg: "[资产编号]单元不能为空"
                        };
                    }
                    // 检查修正 [内部编码]
                    if(!Utils.isNoB(deviceImpDto.innerNo)) {
                        deviceImpDto.innerNo = this.replaceSL(deviceImpDto.innerNo, '');
                        if(deviceImpDto.innerNo.length > 30) {
                            deviceImpDto.validateInfo.upn = {
                                validateOk: false,
                                errorMsg: "[外部系统编号]单元长度最大30，当前[" + deviceImpDto.innerNo.length + "]"
                            };
                        }
                    }
                    // 检查修正 [统一商品代码(UPC)]
                    if(!Utils.isNoB(deviceImpDto.upn)) {
                        deviceImpDto.upn = this.replaceSL(deviceImpDto.upn, '');
                        if(deviceImpDto.upn.length > 30) {
                            deviceImpDto.validateInfo.upn = {
                                validateOk: false,
                                errorMsg: "[统一商品代码(UPC)]单元长度最大30，当前[" + deviceImpDto.upn.length + "]"
                            };
                        }
                    }
                    // 检查 [设备名称]
                    if(!Utils.isNoB(deviceImpDto.devcName)) {
                        deviceImpDto.devcName = this.replaceSL(deviceImpDto.devcName, ' ');
                    }
                    if(Utils.isNoB(deviceImpDto.devcName)) {
                        deviceImpDto.validateInfo.devcName = {
                            validateOk: false,
                            errorMsg: "[名称]单元不可为空"
                        };
                    } else if(deviceImpDto.devcName.length > 30) {
                        deviceImpDto.validateInfo.devcName = {
                            validateOk: false,
                            errorMsg: "[名称]单元长度最大30，当前[" + deviceImpDto.devcName.length + "]"
                        };
                    }
                    // 检查[设备描述全称]
                    if(!Utils.isNoB(deviceImpDto.title)) {
                        deviceImpDto.title = this.replaceSL(deviceImpDto.title, ' ');
                    }
                    if(Utils.isNoB(deviceImpDto.title)) {
                        deviceImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[设备描述全称]单元不可为空"
                        };
                    } else if(deviceImpDto.title.length > 60) {
                        deviceImpDto.validateInfo.title = {
                            validateOk: false,
                            errorMsg: "[设备描述全称]单元长度最大60，当前[" + deviceImpDto.title.length + "]"
                        };
                    }
                    // 检查 [所属店铺]
                    if(deviceImpDto.shopId == null && !byItemFlag) {
                        deviceImpDto.validateInfo.shopName = {
                            validateOk: false,
                            errorMsg: "所属部门不可为空并且要与目标部门名称一致"
                        };
                    }
                    // 检查 [所属店铺]
                    if(deviceImpDto.shopId == null && !byItemFlag) {
                        deviceImpDto.validateInfo.bizUnitName = {
                            validateOk: false,
                            errorMsg: "业务单元不可为空并且要与目标业务单元名称一致"
                        };
                    }
                    if(!deviceImpDto.durable) {
                        // 检查 [启用日期]
                        if(deviceImpDto.initStartDate == null) {
                            deviceImpDto.validateInfo.initStartDate = {
                                validateOk: false,
                                errorMsg: "设备[启用日期]单元不能为空"
                            };
                        }
                    }

                    // 自有设备分类
                    if(Utils.isNoB(deviceImpDto.innerDevcCatId)) {
                        if(!Utils.isNoB(deviceImpDto.innerDevcCatName)) {
                            deviceImpDto.validateInfo.innerDevcCatName = {
                                validateOk: false,
                                errorMsg: "[资产分类]不存在,请预设资产分类"
                            };
                        }
                        if(!Utils.isNoB(deviceImpDto.innerDevcCatCode)) {
                            deviceImpDto.validateInfo.innerDevcCatCode = {
                                validateOk: false,
                                errorMsg: "[资产分类编码]不存在,请预设资产分类"
                            };
                        }
                    }
                    if((!Utils.isNoB(deviceImpDto.innerDevcCatId) || !Utils.isNoB(deviceImpDto.innerDevcCatName) || !Utils.isNoB(deviceImpDto.innerDevcCatCode)) && (Utils.isNoB(deviceImpDto.innerDevcBrandId) || Utils.isNoB(deviceImpDto.innerDevcBrandName) || Utils.isNoB(deviceImpDto.innerDevcBrandCode))) {
                        deviceImpDto.validateInfo.innerDevcBrandName = {
                            validateOk: false,
                            errorMsg: "[资产品牌]不能为空,请预设资产品牌"
                        };
                        deviceImpDto.validateInfo.innerDevcBrandCode = {
                            validateOk: false,
                            errorMsg: "[资产品牌编码]不能为空,请预设资产品牌"
                        };
                    }
                    // 资产品牌
                    if(Utils.isNoB(deviceImpDto.innerDevcBrandId)) {
                        if(!Utils.isNoB(deviceImpDto.innerDevcBrandName)) {
                            deviceImpDto.validateInfo.innerDevcBrandName = {
                                validateOk: false,
                                errorMsg: "[资产品牌]不存在,请预设资产品牌"
                            };
                        }
                        if(!Utils.isNoB(deviceImpDto.innerDevcBrandCode)) {
                            deviceImpDto.validateInfo.innerDevcBrandCode = {
                                validateOk: false,
                                errorMsg: "[资产品牌编码]不存在,请预设资产品牌"
                            };
                        }
                    }
                    if((Utils.isNoB(deviceImpDto.innerDevcCatId) || Utils.isNoB(deviceImpDto.innerDevcCatName) || Utils.isNoB(deviceImpDto.innerDevcCatCode)) && (!Utils.isNoB(deviceImpDto.innerDevcBrandId) || !Utils.isNoB(deviceImpDto.innerDevcBrandName) || !Utils.isNoB(deviceImpDto.innerDevcBrandCode))) {
                        deviceImpDto.validateInfo.innerDevcCatName = {
                            validateOk: false,
                            errorMsg: "[资产分类]不能为空,请预设资产分类"
                        };
                        deviceImpDto.validateInfo.innerDevcCatCode = {
                            validateOk: false,
                            errorMsg: "[资产分类编码]不能为空,请预设资产分类"
                        };
                    }
                    // 检查 [商品分类]
                    if(deviceImpDto.catId == null && !byItemFlag) {
                        deviceImpDto.validateInfo.catName = {
                            validateOk: false,
                            errorMsg: "此商品分类不存在,请设置商品分类"
                        };
                    }
                    // 检查 [品牌]
                    if(deviceImpDto.brandId == null && !byItemFlag) {
                        deviceImpDto.validateInfo.brandName = {
                            validateOk: false,
                            errorMsg: "此商品品牌不存在,请设置商品品牌"
                        };
                    }

                    // 检查 [型号]
                    if(!Utils.isNoB(deviceImpDto.model)) {
                        deviceImpDto.model = this.replaceSL(deviceImpDto.model, ' ');
                    }
                    if(Utils.isNoB(deviceImpDto.model)) {
                        //
                    } else if(deviceImpDto.model.length > 30) {
                        deviceImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号]单元长度最大30，当前[" + deviceImpDto.model.length + "]"
                        };
                    }
                    // 检查 [规格]
                    if(!Utils.isNoB(deviceImpDto.fixedSpec)) {
                        deviceImpDto.fixedSpec = this.replaceSL(deviceImpDto.fixedSpec, ' ');
                    }
                    if(Utils.isNoB(deviceImpDto.fixedSpec) && deviceImpDto.fixedSpec != '') {
                        deviceImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元不能为空"
                        };
                    } else if(deviceImpDto.fixedSpec.length > 45) {
                        deviceImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[规格]单元长度最大45，当前[" + deviceImpDto.fixedSpec.length + "]"
                        };
                    }
                    //
                    let modelSpec = deviceImpDto.model + deviceImpDto.fixedSpec;
                    if(Utils.isNoB(modelSpec) || modelSpec.length > 60) {
                        deviceImpDto.validateInfo.model = {
                            validateOk: false,
                            errorMsg: "[型号 + 规格]单元长度最大60，当前[" + deviceImpDto.model.length + "]"
                        };
                        deviceImpDto.validateInfo.fixedSpec = {
                            validateOk: false,
                            errorMsg: "[型号 + 规格]单元长度最大60，当前[" + deviceImpDto.fixedSpec.length + "]"
                        };
                    }
                    // 检查修正 [供商统一社会信用码]
                    if(!Utils.isNoB(deviceImpDto.innerVendorNo)) {
                        deviceImpDto.innerVendorNo = this.replaceSL(deviceImpDto.innerVendorNo, '');
                        if(deviceImpDto.innerVendorNo.length > 30) {
                            deviceImpDto.validateInfo.innerVendorNo = {
                                validateOk: false,
                                errorMsg: "[供商统一社会信用码]单元长度最大30，当前[" + deviceImpDto.innerVendorNo.length + "]"
                            };
                        }
                    }
                    // 检查修正 [厂商序列号]
                    if(!deviceImpDto.durable) {
                        if(!Utils.isNoB(deviceImpDto.vendorSn)) {
                            deviceImpDto.vendorSn = this.replaceSL(deviceImpDto.vendorSn, '');
                            if(!Utils.isNaturalStr(deviceImpDto.quantity, true) || deviceImpDto.quantity != 1) {
                                deviceImpDto.validateInfo.vendorSn = {
                                    validateOk: false,
                                    errorMsg: "[厂商序列号]单元有效时数量必须为1"
                                };
                            } else {
                                if(deviceImpDto.vendorSn.length > 30) {
                                    deviceImpDto.validateInfo.vendorSn = {
                                        validateOk: false,
                                        errorMsg: "[厂商序列号]单元长度最大30，当前[" + deviceImpDto.vendorSn.length + "]"
                                    };
                                }
                            }
                        }
                    }
                    // 检查 [数量]
                    if(deviceImpDto.durable) {
                        if(!Utils.isNaturalStr(deviceImpDto.quantity, true)) {
                            deviceImpDto.validateInfo.quantity = {
                                validateOk: false,
                                errorMsg: "[数量]单元不能为空并且必须为大于0的整数"
                            };
                        }
                    } else {
                        if(!Utils.isNaturalStr(deviceImpDto.quantity, true) || deviceImpDto.quantity > self.max_quantity_per_item) {
                            deviceImpDto.validateInfo.quantity = {
                                validateOk: false,
                                errorMsg: "[数量]单元不能为空并且必须为 1 ~ " + self.max_quantity_per_item + " 的整数"
                            };
                        }
                    }
                    // 检查 [单位]
                    if(!Utils.isNoB(deviceImpDto.theUnit)) {
                        deviceImpDto.theUnit = this.replaceSL(deviceImpDto.theUnit, '');
                        if(deviceImpDto.theUnit.length > 5) {
                            deviceImpDto.validateInfo.theUnit = {
                                validateOk: false,
                                errorMsg: "[单位]单元长度最大5，当前[" + deviceImpDto.theUnit.length + "]"
                            };
                        }
                    }
                    //
                    if(!deviceImpDto.durable) {
                        // 检查 [购买日期] 和 [收货日期] 必具其一，并且 [收货日期] >= [购买日期]
                        let curDate = new Date().format('yyyy-MM-dd');
                        if(deviceImpDto.buyDate == null && deviceImpDto.recvDate == null) {
                            deviceImpDto.validateInfo.buyDate = {
                                validateOk: false,
                                errorMsg: "[购买日期] 和 [收货日期]单元 不能同时为空"
                            };
                            deviceImpDto.validateInfo.recvDate = {
                                validateOk: false,
                                errorMsg: "[收货日期]单元 不能为空"
                            };
                        } else if(deviceImpDto.buyDate != null) {
                            if(deviceImpDto.buyDate > curDate) {
                                deviceImpDto.validateInfo.buyDate = {
                                    validateOk: false,
                                    errorMsg: "[购买日期] 不能晚于今天"
                                };
                            }
                            if(deviceImpDto.recvDate != null && deviceImpDto.recvDate < deviceImpDto.buyDate) {
                                deviceImpDto.validateInfo.recvDate = {
                                    validateOk: false,
                                    errorMsg: "[收货日期] 不能早于 [购买日期]"
                                };
                            }
                        } else if(deviceImpDto.recvDate > curDate) {
                            deviceImpDto.validateInfo.recvDate = {
                                validateOk: false,
                                errorMsg: "[收货日期]不能晚于今天"
                            };
                        }
                    }
                    // 检查修正 [服务商] : 不是必需的
                    if(deviceImpDto.servicerName != null && deviceImpDto.servicerId == null) {
                        deviceImpDto.validateInfo.servicerName = {
                            validateOk: false,
                            errorMsg: "此[服务商]不存在,请设置或清除服务商"
                        };
                    }
                    // 检查修正 [质保期]
                    if(deviceImpDto.wrntPeriod != null) {
                        if(!Utils.isNaturalStr(deviceImpDto.wrntPeriod, true) || deviceImpDto.wrntPeriod <= 0) {
                            deviceImpDto.validateInfo.wrntPeriod = {
                                validateOk: false,
                                errorMsg: "[质保期(月)]单元为 > 0 的整数"
                            };
                        }
                    }
                    // 检查责任部门 检查责任人
                    if(Utils.isNoB(deviceImpDto.departName) && Utils.isNoB(deviceImpDto.departNo)) {
                        if(!Utils.isNoB(deviceImpDto.principalName)) {
                            deviceImpDto.validateInfo.departName = {
                                validateOk: false,
                                errorMsg: "请先设置[责任部门]"
                            };
                            deviceImpDto.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: "请先设置[责任部门]"
                            };
                        }
                    } else {
                        if(deviceImpDto.departId == null) {
                            deviceImpDto.validateInfo.departName = {
                                validateOk: false,
                                errorMsg: "[责任部门]单元对应的部门在本机构未找到"
                            };
                            deviceImpDto.validateInfo.principalName = {
                                validateOk: false,
                                errorMsg: "[责任部门]单元对应的部门在本机构未找到"
                            };
                        } else {
                            if((!Utils.isNoB(deviceImpDto.principalName) || !Utils.isNoB(deviceImpDto.principalNo)) && deviceImpDto.principalId == null) {
                                deviceImpDto.validateInfo.principalName = {
                                    validateOk: false,
                                    errorMsg: "[责任人]异常,请手动设置"
                                };
                            }
                        }
                    }
                    // 检查修正 [备注]
                    if(!Utils.isNoB(deviceImpDto.memo)) {
                        if(deviceImpDto.memo.length > 60) {
                            deviceImpDto.validateInfo.memo = {
                                validateOk: false,
                                errorMsg: "[备注]单元长度最大60，当前[" + deviceImpDto.memo.length + "]"
                            };
                        }
                    }
                    // 特种设备
                    if(deviceImpDto.durable) {
                        deviceImpDto.specialFlag = false;
                    }
                }
                //记录被选中的行
                let oldSelectedRowNos = this.multipleSelection.pluck('rowNo');
                //
                this.deviceImpDto.deviceImpInfoList = rows;
                this.setPageDeviceImpInfoList();
                //（必须）延迟恢复被选中的行
                setTimeout(function () {
                    self.deviceImpDto.deviceImpInfoList.forEach(function (row) {
                        if(oldSelectedRowNos.indexOf(row.rowNo) != -1) {
                            self.$refs.deviceImpInfoTable.toggleRowSelection(row);
                        }
                    });
                }, 1000);
            },
            setPageDeviceImpInfoList: function () {
                let totalRows = this.deviceImpDto.deviceImpInfoList;
                let start = (this.pageNumber - 1) * this.pageSize;
                let end = this.pageNumber * this.pageSize;
                let rows = totalRows.slice(start, end);
                this.pageDeviceImpInfoList = rows;
                this.totalCount = totalRows.length;
            },
            handleSizeChange: function (val) {
                this.pageSize = val;
                this.handlePageChange(1);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.setPageDeviceImpInfoList();
            },
            getDlgResult: function () {
                let self = this;
                // 虚拟品牌校验
                let virtualBrandStr = this.virtualBrandStr;
                let virtualBrand = [];
                if(!Utils.isNoB(virtualBrandStr)) {
                    virtualBrand = virtualBrandStr.split('|');
                }
                if(!Utils.isNoB(this.deviceImpDto.warehouseId)) {
                    self.warehouseList.forEach(function (ware) {
                        if(self.deviceImpDto.warehouseId == ware.id) {
                            self.deviceImpDto.warehouseName = ware.name;
                        }
                    });
                }
                this.deviceImpDto.dumyBrandNames = virtualBrand;
                // @date 2019-02-22 16:12 @author libin @desc 增加虚拟导入字段信息
                this.deviceImpDto.virtualFlag = false;
                return this.deviceImpDto;
            },
            dlgSetDeviceImpDto: function (deviceImpDto) {
                let deviceImpInfoList = deviceImpDto.deviceImpInfoList;
                deviceImpInfoList.forEach(function (el) {
                    el.validateInfo = {
                        devcName: {validateOk: true},
                        shopName: {validateOk: true},
                        bizUnitName: {validateOk: true},
                        catName: {validateOk: true},
                        brandName: {validateOk: true},
                        model: {validateOk: true},
                        fixedSpec: {validateOk: true},
                        quantity: {validateOk: true},
                        buyDate: {validateOk: true},
                        recvDate: {validateOk: true},
                        servicerName: {validateOk: true}
                    };
                });
                this.deviceImpDto = deviceImpDto;
                let self = this;
                setTimeout(
                    function () {
                        self.checkData();
                    }, 1000
                );
            },
            // 资产分类
            setDevcCat(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let params = {
                                    checkBox: false,
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false,
                                        level: 3
                                    }
                                };
                                showDevcCatSelectDlg(params, function (devcCat, theDlg) {
                                    theDlg.close();
                                    devcCat = devcCat || {};
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.deviceImpDto.deviceImpInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        model.innerDevcCatId = devcCat.id;
                                        model.innerDevcCatCode = devcCat.code;
                                        model.innerDevcCatName = devcCat.name;
                                        if(!Utils.isNoB(devcCat.goodsCatId)) {
                                            model.catName = devcCat.goodsCatName;
                                            model.catId = devcCat.goodsCatId;
                                        }
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置')
                ])
            },
            // 资产品牌
            setDevcBrand(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                showDevcBrandSelectDlg({
                                    checkBox: false,
                                    filter: {
                                        relSysFlag: true,
                                        disabled: false
                                    }
                                }, function (devcBrand, theDlg) {
                                    theDlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.deviceImpDto.deviceImpInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        model.innerDevcBrandId = devcBrand.id;
                                        model.innerDevcBrandCode = devcBrand.code;
                                        model.innerDevcBrandName = devcBrand.name;
                                        if(!Utils.isNoB(devcBrand.sysBrandId) && devcBrand.sysBrandId != -1) {
                                            model.brandName = devcBrand.sysBrandName;
                                            model.brandId = devcBrand.sysBrandId;
                                        }
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            // 商品分类
            setCat(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                for(var i = 0; i < self.multipleSelection.length; i++) {
                                    var obj = self.multipleSelection[i];
//                                    if(obj.devcDefId != null) {
//                                        MsgBox.warning("关联定义的设备不可修改分类、品牌、规格等信息");
//                                        return;
//                                    }
                                }
                                let params = {
                                    multipleSelect: false
                                };
                                openCategTreeSelectDlg(params, [], function (catList) {
                                    catList = catList || [];
                                    let categ = catList[0];
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        let tmpRow = self.multipleSelection[i];
                                        let model = self.deviceImpDto.deviceImpInfoList.find(function (row) {
                                            return row.rowNo == tmpRow.rowNo;
                                        });
                                        model.catName = categ.catName;
                                        model.catId = categ.catId;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setServicer(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let theDlg = Vue.$showDialog({
                                    title: '选择服务商',
                                    height: '80%',
                                    showCloseBtn: true,
                                    template: '<div>' +
                                    '<swb-def-servicer-for-select :multiSelect="false" :initCheckedItem="initCheckedItem" ref="swb_def_servicer_for_select"></swb-def-servicer-for-select>' +
                                    '</div>',
                                    data: {
                                        initCheckedItem: {
                                            id: null,
                                            name: null
                                        }
                                    },
                                    okClicked: function () {
                                        let result = this.$refs.swb_def_servicer_for_select.getDlgResult() || {};
                                        if(result.type == "info") {
                                            let servicer = result.data;
                                            for(var i = 0; i < self.multipleSelection.length; i++) {
                                                self.multipleSelection[i].servicerName = servicer.name;
                                                self.multipleSelection[i].servicerId = servicer.id;
                                            }
                                            self.checkData();
                                            return true;
                                        } else {
                                            self.$message.warning(result.message);
                                        }
                                        return false;
                                    },
                                    methods: {}
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的服务商?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].servicerName = null;
                                        self.multipleSelection[i].servicerId = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setInitStartDate(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("initStartDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的启用日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(var i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].initStartDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setBuyDate(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("buyDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的购买日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].buyDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setRecvDate(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("recvDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的收货日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].recvDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setOnsetDate(h){
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                self.setDate("onsetDate");
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的折旧起算日期?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].onsetDate = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setDate(type, formatType) {
                let self = this;
                if(self.multipleSelection.length == 0) {
                    self.$message.warning("请勾选要设置的行");
                    return;
                }
                let theDlg = Vue.$showDialog({
                    title: '选择日期',
                    width: 300,
                    height: 200,
                    showCloseBtn: true,
                    template: '<div>' +
                    '<swb-shop-device-imp-set-date :formatType="formatType" ref="swb_shop_device_imp_set_date"></swb-shop-device-imp-set-date>' +
                    '</div>',
                    data: {
                        formatType: formatType
                    },
                    okClicked: function () {
                        let result = this.$refs.swb_shop_device_imp_set_date.getDlgResult() || {};
                        if(result.type == "info") {
                            let selectDate = result.data;
                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                self.multipleSelection[i][type] = selectDate;
                            }
                            self.checkData();
                            return true;
                        } else {
                            self.$message.warning(result.message);
                        }
                        return false;
                    },
                    methods: {}
                });
            },
            setBrand(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let catId = null;
                                for(var i = 0; i < self.multipleSelection.length; i++) {
                                    var obj = self.multipleSelection[i];
//                                    if(obj.devcDefId != null) {
//                                        MsgBox.warning("关联定义的设备不可修改分类、品牌、规格等信息");
//                                        return;
//                                    }
                                    if(obj.catId == null) {
                                        MsgBox.warning("请选择已设置分类的行");
                                        return;
                                    }
                                    if(catId == null) {
                                        catId = obj.catId;
                                    } else if(catId != obj.catId) {
                                        MsgBox.warning("请选择相同分类的行");
                                        return;
                                    }
                                }
                                let params = {
                                    selectIds: [],
                                    catId: catId
                                };
                                openBrandListSelectDlg(false, params, function (brand) {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].brandName = brand.dispName;
                                        self.multipleSelection[i].brandId = brand.id;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                ])
            },
            setDepart(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                Vue.$showDialog({
                                    title: '责任部门 - 选择',
                                    width: 750,
                                    height: 600,
                                    showCloseBtn: true,
                                    template: '<swb-org-tree  :bizUnitId="bizUnitId" :comFlag="true" :isRadio="true" :bizDepart="true"  ref="swb_org_tree"></swb-org-tree>',
                                    data: {
                                        bizUnitId: self.deviceImpDto.retailerBizUnitId
                                    },
                                    okClicked: function () {
                                        let result = this.$refs.swb_org_tree.getDlgResult() || {};
                                        if(result.type == "info") {
                                            let selectComInfo = result.data;
                                            for(let i = 0; i < self.multipleSelection.length; i++) {
                                                self.multipleSelection[i].departId = selectComInfo.id;
                                                self.multipleSelection[i].departName = selectComInfo.name;
                                                self.multipleSelection[i].departNo = selectComInfo.no;
                                            }
                                            self.checkData();
                                        } else {
                                            return false;
                                        }
                                    }
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的责任部门?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].departId = null;
                                        self.multipleSelection[i].departName = null;
                                        self.multipleSelection[i].departNo = null;
                                        self.multipleSelection[i].principalId = null;
                                        self.multipleSelection[i].principalName = null;
                                        self.multipleSelection[i].principalNo = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setBathPrincipal(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                let departIds = self.multipleSelection.pluck("departId");
                                let departIdList = [];
                                departIds.forEach(function (departId) {
                                    if(!departIdList.contains(departId)) {
                                        departIdList.push(departId);
                                    }
                                });
                                if(departIdList.length > 1) {
                                    MsgBox.warning("请选择相同的责任部门进行批量设置责任人");
                                    return;
                                }
                                let departId = departIdList[0];
                                if(Utils.isNoB(departId)) {
                                    MsgBox.warning("必须选择已设置责任部门的行进行设置责任人");
                                    return;
                                }
                                openComStaffComnSelectDlg(departId, false, function (resultData, theDlg) {
                                    theDlg.close();
                                    let departStaff = resultData.data || {};
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].principalId = departStaff.id;
                                        self.multipleSelection[i].principalName = departStaff.name;
                                        self.multipleSelection[i].principalNo = departStaff.staff.no;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '设置'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的责任人?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].principalId = null;
                                        self.multipleSelection[i].principalName = null;
                                        self.multipleSelection[i].principalNo = null;
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setPrincipal(row) {
                let self = this;
                if(Utils.isNoB(row.departId)) {
                    MsgBox.warning("请先设置责任部门");
                } else {
                    openComStaffComnSelectDlg(row.departId, false, function (resultData, theDlg) {
                        theDlg.close();
                        let departStaff = resultData.data || {};
                        for(let i = 0; i < self.multipleSelection.length; i++) {
                            self.multipleSelection[i].principalId = departStaff.staffId;
                            self.multipleSelection[i].principalName = departStaff.name;
                            self.multipleSelection[i].principalNo = departStaff.staff.no;
                        }
                        self.checkData();
                    });
                }
            },
            delPrincipal(row) {
                row.principalId = null;
                row.principalName = null;
                row.principalNo = null;
                this.checkData();
            },
            autoSetBatchNo(h)  {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                let rows = self.deviceImpDto.deviceImpInfoList.clone();
                                for(let i = 0; i < rows.length; i++) {
                                    let deviceImpDto = rows[i];
                                    if(Utils.isNoB(deviceImpDto.batchNo)) {
                                        let batchNoDate = new Date();
                                        // if(!deviceImpDto.durable) {
                                        if(!Utils.isNoB(deviceImpDto.buyDate)) {
                                            batchNoDate = deviceImpDto.buyDate;
                                        } else if(!Utils.isNoB(deviceImpDto.recvDate)) {
                                            batchNoDate = deviceImpDto.recvDate;
                                        }
                                        //}
                                        //
                                        deviceImpDto.batchNo = new Date(batchNoDate).format('yyyyMMdd');
                                        if(!Utils.isNoB(self.uknoPrefix)) {
                                            deviceImpDto.innerCode = self.uknoPrefix + deviceImpDto.batchNo;
                                        }
                                    }
                                }
                                self.checkData();
                            }
                        }
                    }, '自动生成批次号'),
                ])
            },
            getShopDeviceList()  {
                alert(1);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 逐条检查
            validateDeviceImpModel: function (isFirst) {
                this.checkNextIndex = isFirst ? 0 : this.checkNextIndex;
                this.startFlag = true;
                let self = this;
                this.getDlgResult();
                let deviceImpDto = this.deviceImpDto;
                //
                let srcDeviceImpInfoList = deviceImpDto.deviceImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                console.log(srcListLength);
                //
                let checkNextIndex = this.checkNextIndex;
                let srcImpInfo = srcDeviceImpInfoList[checkNextIndex];
                let postData = Utils.merge({}, deviceImpDto);
                postData.deviceImpInfoList = [srcImpInfo];
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                shopDevcApi.validateOuterUnsettledImpModel(postData, function (result) {
                    theLoading.hide();
                    let callItem = result.data.deviceImpInfoList[0];
                    if(result.type == 'info') {
                        callItem.failed = false;
                        callItem.failDesc = null;
                    } else {
                        callItem.failed = true;
                        callItem.failDesc = result.message;
                    }
                    srcDeviceImpInfoList[checkNextIndex] = Utils.merge({}, callItem);
                    deviceImpDto.deviceImpInfoList = srcDeviceImpInfoList;
                    self.deviceImpDto = Utils.merge({}, deviceImpDto);
                    self.checkData();
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (checkNextIndex + 1) / pageSize;
                    let pageNumber2 = (checkNextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    self.handlePageChange(pageNumber);
                    // self.pageDeviceImpInfoList = Utils.merge([], srcDeviceImpInfoList);
                    //
                    if(checkNextIndex < srcListLength - 1) {
                        self.checkNextIndex += 1;
                        self.validateDeviceImpModel(false);
                    } else {
                        self.handlePageChange(1);
                    }
                });
            },
            // 逐条检查导入
            doDeviceImpModelImport() {
                let self = this;
                this.getDlgResult();
                let deviceImpDto = this.deviceImpDto;
                let theLoading = MsgBox.loading("正在执行导入");
                shopDevcApi.doDeviceOuterUnsettledImpModelImport(deviceImpDto, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        if(result.data) {
                            self.$emit('other-close', result.data);
                        } else {
                            MsgBox.warning('请检查通过再导入');
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            doDeviceImpModelImportStart()  {
                this.startFlag = true;
                let srcDeviceImpDto = this.deviceImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.deviceImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                //
                let paramDeviceImpDto = {};
                paramDeviceImpDto.retailerId = srcDeviceImpDto.retailerId;
                paramDeviceImpDto.retailerShopId = srcDeviceImpDto.retailerShopId;
                paramDeviceImpDto.retailerBizUnitId = srcDeviceImpDto.retailerBizUnitId;
                paramDeviceImpDto.originalFileName = srcDeviceImpDto.originalFileName;
                paramDeviceImpDto.dumyBrandNames = srcDeviceImpDto.dumyBrandNames;
                paramDeviceImpDto.warehouseId = srcDeviceImpDto.warehouseId;
                paramDeviceImpDto.warehouseName = srcDeviceImpDto.warehouseName;
                paramDeviceImpDto.virtualFlag = srcDeviceImpDto.virtualFlag;
                paramDeviceImpDto.virtualType = srcDeviceImpDto.virtualType;
                paramDeviceImpDto.srcVoucherType = srcDeviceImpDto.srcVoucherType;
                paramDeviceImpDto.srcVoucherNo = srcDeviceImpDto.srcVoucherNo;
                paramDeviceImpDto.importRecId = srcDeviceImpDto.importRecId;
                paramDeviceImpDto.ioVoucherId = srcDeviceImpDto.ioVoucherId;
                paramDeviceImpDto.deviceFlag = srcDeviceImpDto.deviceFlag;
                //
                this.startDone(paramDeviceImpDto);
            },
            startDone(paramDeviceImpDto)  {
                let self = this;
                let nextIndex = this.nextIndex;
                let srcDeviceImpDto = this.deviceImpDto;
                let srcDeviceImpInfoList = srcDeviceImpDto.deviceImpInfoList;
                let srcListLength = srcDeviceImpInfoList.length;
                let srcImpInfo = srcDeviceImpInfoList[nextIndex];
                paramDeviceImpDto.deviceImpInfoList = [srcImpInfo];
                //
                paramDeviceImpDto.lastFlag = Utils.isTrue(nextIndex == (srcListLength - 1));   // 是否最后一条数据
                //
                let theLoading = MsgBox.loading("【源件行号：" + srcImpInfo.rowNo + "】正在处理，请稍后...");
                shopDevcApi.doDeviceOuterUnsettledImpModelImport(paramDeviceImpDto, function (result) {
                    theLoading.close();
                    let resultDto = result.data;
                    if(result.type == 'info') {
                        paramDeviceImpDto.importRecId = resultDto.importRecId;
                        paramDeviceImpDto.ioVoucherId = resultDto.ioVoucherId;
                        if(srcDeviceImpDto.importRecId == null) {
                            srcDeviceImpDto.importRecId = resultDto.importRecId;
                            srcDeviceImpDto.ioVoucherId = resultDto.ioVoucherId;
                        }
                        srcImpInfo.failed = false;
                        srcImpInfo.failDesc = null;
                    } else {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = result.message;
                        console.error(result.message);
                        if(paramDeviceImpDto.importRecId == null) {
                            // 第一条都没过去，记录没生成
                            MsgBox.warning(result.message);
                            return;
                        } else {

                        }
                    }
                    //
                    let pageSize = self.pageSize;
                    let pageNumber = (nextIndex + 1) / pageSize;
                    let pageNumber2 = (nextIndex + 1) % pageSize;
                    if(pageNumber2 != 0) {
                        pageNumber = pageNumber + 1;
                    }
                    if(!Utils.isNoB(resultDto) && !Utils.isNoB(resultDto.errMsg)) {
                        srcImpInfo.failed = true;
                        srcImpInfo.failDesc = resultDto.errMsg;
                        self.handlePageChange(pageNumber);
                        MsgBox.warning("源件行号：" + srcImpInfo.rowNo + "】:" + resultDto.errMsg);
                    } else {
                        self.handlePageChange(pageNumber);
                        //
                        if(nextIndex < (srcListLength - 1)) {
                            self.nextIndex = nextIndex + 1;
                            self.startDone(paramDeviceImpDto);
                        } else {
                            self.$emit('other-close', paramDeviceImpDto.importRecId);
                        }
                    }
                });
            },
            replaceSL(str, char) {
                if(!Utils.isNoB(str)) {
                    str = Utils.replace(str, '\r\n', char);
                    str = Utils.replace(str, '\r', char);
                    str = Utils.replace(str, '\n', char);
                }
                return str;
            },
            setBathDevcDef(h) {
                let self = this;
                return h('span', [
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要设置的行");
                                    return;
                                }
                                //
                                let durableCount = 0;
                                let singleCount = 0;
                                for(let i = 0; i < self.multipleSelection.length; i++) {
                                    let item = self.multipleSelection[i];
                                    if(Utils.isTrue(item.durable)) {
                                        durableCount += 1;
                                    } else {
                                        singleCount += 1;
                                    }
                                }
                                if(durableCount > 0 && singleCount > 0) {
                                    self.$message.warning("勾选的行必须都是批量的或者都是单品的");
                                    return;
                                }
                                let params = {};
                                if(durableCount > 0) {
                                    params.assetType = 1;
                                } else {
                                    params.assetType = 0;
                                }
                                showMerchtDevcDefSelectDlg(params, function (devcDef, dlg) {
                                    dlg.close();
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        self.multipleSelection[i].devcDefId = devcDef.id;
                                        self.multipleSelection[i].devcDefCode = devcDef.innerCode;
                                        self.multipleSelection[i].srcData = Utils.merge({}, self.multipleSelection[i]);
                                        self.multipleSelection[i].catId = devcDef.catId;
                                        self.multipleSelection[i].catName = devcDef.catName;
                                        self.multipleSelection[i].brandId = devcDef.brandId;
                                        self.multipleSelection[i].brandName = devcDef.brandName;
                                        self.multipleSelection[i].devcName = devcDef.name;
                                        self.multipleSelection[i].title = devcDef.title;
                                        self.multipleSelection[i].theUnit = devcDef.theUnit;
                                        self.multipleSelection[i].model = devcDef.model;
                                        self.multipleSelection[i].fixedSpec = devcDef.fixedSpec;
                                        self.multipleSelection[i].fixedSpecCode = devcDef.innerCode;
                                        self.multipleSelection[i].rmnWorthRatio = devcDef.rmnWorthRatio;
                                        self.multipleSelection[i].setupFlag = devcDef.setupFlag;
                                        self.multipleSelection[i].innerDevcCatId = devcDef.innerDevcCatId;
                                        self.multipleSelection[i].innerDevcCatCode = devcDef.innerDevcCode;
                                        self.multipleSelection[i].innerDevcCatName = devcDef.innerDevcCatName;
                                        self.multipleSelection[i].innerDevcBrandId = devcDef.innerDevcBrandId;
                                        self.multipleSelection[i].innerDevcBrandCode = devcDef.innerDevcBrandCode;
                                        self.multipleSelection[i].innerDevcBrandName = devcDef.innerDevcBrandName;
                                    }
                                    self.checkData();
                                });
                            }
                        }
                    }, '选择'),
                    h('a', {
                        class: 'swb-btn swb-btn-link',
                        on: {
                            click: function () {
                                if(self.multipleSelection.length == 0) {
                                    self.$message.warning("请勾选要清除的行");
                                    return;
                                }
                                //弹出确认框
                                self.$confirm('确认要清除所选行的关联定义吗?', '提示', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(function () {
                                    for(let i = 0; i < self.multipleSelection.length; i++) {
                                        if(self.multipleSelection[i].devcDefId != null) {
                                            self.multipleSelection[i].devcDefId = null;
                                            self.multipleSelection[i].devcDefCode = null;
                                            self.multipleSelection[i].catId = self.multipleSelection[i].srcData.catId;
                                            self.multipleSelection[i].catName = self.multipleSelection[i].srcData.catName;
                                            self.multipleSelection[i].brandId = self.multipleSelection[i].srcData.brandId;
                                            self.multipleSelection[i].brandName = self.multipleSelection[i].srcData.brandName;
                                            self.multipleSelection[i].devcName = self.multipleSelection[i].srcData.devcName;
                                            self.multipleSelection[i].title = self.multipleSelection[i].srcData.title;
                                            self.multipleSelection[i].theUnit = self.multipleSelection[i].srcData.theUnit;
                                            self.multipleSelection[i].model = self.multipleSelection[i].srcData.model;
                                            self.multipleSelection[i].fixedSpec = self.multipleSelection[i].srcData.fixedSpec;
                                            self.multipleSelection[i].fixedSpecCode = self.multipleSelection[i].srcData.fixedSpecCode;
                                            self.multipleSelection[i].rmnWorthRatio = self.multipleSelection[i].srcData.rmnWorthRatio;
                                            self.multipleSelection[i].setupFlag = self.multipleSelection[i].srcData.setupFlag;
                                            self.multipleSelection[i].innerDevcCatId = self.multipleSelection[i].srcData.innerDevcCatId;
                                            self.multipleSelection[i].innerDevcCatCode = self.multipleSelection[i].srcData.innerDevcCatCode;
                                            self.multipleSelection[i].innerDevcCatName = self.multipleSelection[i].srcData.innerDevcCatName;
                                            self.multipleSelection[i].innerDevcBrandId = self.multipleSelection[i].srcData.innerDevcBrandId;
                                            self.multipleSelection[i].innerDevcBrandCode = self.multipleSelection[i].srcData.innerDevcBrandCode;
                                            self.multipleSelection[i].innerDevcBrandName = self.multipleSelection[i].srcData.innerDevcBrandName;
                                            self.multipleSelection[i].srcData = null;
                                        }
                                    }
                                    self.checkData();
                                }).catch(function () {
                                });
                            }
                        }
                    }, '清除')
                ])
            },
            setDevcDef(row) {
                let self = this;
                let assetType = null;
                if(Utils.isTrue(row.durable)) {
                    assetType = 1;
                } else {
                    assetType = 0;
                }
                let modelSpec = row.model + '' + row.fixedSpec;
                showMerchtDevcDefSelectDlg({
                    catId: row.catId,
                    brandId: row.brandId,
                    modelSpec: modelSpec,
                    assetType: assetType
                }, function (devcDef, dlg) {
                    dlg.close();
                    row.devcDefId = devcDef.id;
                    row.devcDefCode = devcDef.innerCode;
                    row.srcData = Utils.merge({}, row);
                    row.catId = devcDef.catId;
                    row.catName = devcDef.catName;
                    row.brandId = devcDef.brandId;
                    row.brandName = devcDef.brandName;
                    row.devcName = devcDef.name;
                    row.title = devcDef.title;
                    row.theUnit = devcDef.theUnit;
                    row.model = devcDef.model;
                    row.fixedSpec = devcDef.fixedSpec;
                    row.fixedSpecCode = devcDef.innerCode;
                    row.rmnWorthRatio = devcDef.rmnWorthRatio;
                    row.setupFlag = devcDef.setupFlag;
                    row.innerDevcCatId = devcDef.innerDevcCatId;
                    row.innerDevcCatCode = devcDef.innerDevcCode;
                    row.innerDevcCatName = devcDef.innerDevcCatName;
                    row.innerDevcBrandId = devcDef.innerDevcBrandId;
                    row.innerDevcBrandCode = devcDef.innerDevcBrandCode;
                    row.innerDevcBrandName = devcDef.innerDevcBrandName;
                    self.checkData();
                });
            },
            delDevcDef(row) {
                if(row.devcDefId != null) {
                    row.devcDefId = null;
                    row.devcDefCode = null;
                    row.catId = row.srcData.catId;
                    row.catName = row.srcData.catName;
                    row.brandId = row.srcData.brandId;
                    row.brandName = row.srcData.brandName;
                    row.devcName = row.srcData.devcName;
                    row.title = row.srcData.title;
                    row.theUnit = row.srcData.theUnit;
                    row.model = row.srcData.model;
                    row.fixedSpec = row.srcData.fixedSpec;
                    row.fixedSpecCode = row.srcData.fixedSpecCode;
                    row.rmnWorthRatio = row.srcData.rmnWorthRatio;
                    row.setupFlag = row.srcData.setupFlag;
                    row.innerDevcCatId = row.srcData.innerDevcCatId;
                    row.innerDevcCatCode = row.srcData.innerDevcCatCode;
                    row.innerDevcCatName = row.srcData.innerDevcCatName;
                    row.innerDevcBrandId = row.srcData.innerDevcBrandId;
                    row.innerDevcBrandCode = row.srcData.innerDevcBrandCode;
                    row.innerDevcBrandName = row.srcData.innerDevcBrandName;
                    row.srcData = null;
                }
                this.checkData();
            },
            showDevcDef(id){
                openDevcDefDetailDlg(id);
            },
            formatMonth(date){
                return new Date(date).format('yyyy-MM');
            }
        }
    }
</script>

<style>
    .el-table .selected-row {
        background: #c9e5f5;
    }
</style>



// WEBPACK FOOTER //
// src/compo/retailer/AssetOuterUnsettledImpCheck.vue